module.exports = __webpack_public_path__ + "ni.svg?fd764d41255c66de30ab88104bf0970e";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/ni.svg
// module id = 1147
// module chunks = 27